/**
 * CMapVisionIFrame - 可视化数据地图
 * @author Tevin
 */

import PropTypes from 'prop-types';
import {} from 'antd';
import {} from '@ant-design/icons';
import { CMapIFrame } from './CMapIFrame';
import { Tools } from '@components/common/Tools';
import './cMapIFrame.scss';

export class CMapVisionIFrame extends CMapIFrame {
    static propTypes = {
        // 样式名
        className: PropTypes.string,
        // 是否正在加载
        loading: PropTypes.bool,
        // 加载进度百分比
        loadPercent: PropTypes.number,
        // 加载iframe的回调函数
        onLoadIFrame: PropTypes.func,
    };

    static defaultProps = {
        needMapV: true,
    };

    constructor(props) {
        super(props);
        this._mapvLayer = {
            dataSet: null,
            layer: null,
            lastHover: null,
            clickListener: () => null,
            hoverListener: () => null,
        };
        this._labelPoint = {
            canvas: null,
            ctx: null,
            pointImgs: {},
        };
    }

    _handleLoaded() {
        this.$refs.iframe.contentWindow.initBadiuMap((bMap, BMap, mapv) => {
            this.$refs.iframe.contentWindow.document.body.className = 'service-map';
            this._initMapVLayer(bMap, BMap, mapv);
            this.props.onLoadIFrame({ bMap, BMap });
        });
    }

    _initMapVLayer(bMap, BMap, mapv) {
        this._mapvLayer.dataSet = new mapv.DataSet([]);
        this._mapvLayer.layer = new mapv.baiduMapLayer(
            bMap,
            this._mapvLayer.dataSet,
            this._createOptions(),
        );
    }

    _createOptions() {
        const options = {
            draw: 'icon',
            methods: {
                click: item => {
                    this._mapvLayer.clickListener(item);
                },
                mousemove: item => {
                    // hover 元素
                    if (item) {
                        this._mapvLayer.layer.canvasLayer.canvas.style.cursor = 'pointer';
                        if (this._mapvLayer.lastHover !== item) {
                            this._mapvLayer.lastHover = item;
                            this._mapvLayer.hoverListener(item);
                        }
                    } else {
                        this._mapvLayer.layer.canvasLayer.canvas.style.cursor =
                            'url("https://api.map.baidu.com/images/openhand.cur") 8 8, default';
                        this._mapvLayer.lastHover = null;
                    }
                },
            },
        };
        return options;
    }

    _createLabelImg(data, callback) {
        if (!this._labelPoint.ctx) {
            this._labelPoint.canvas = document.createElement('canvas');
            this._labelPoint.ctx = this._labelPoint.canvas.getContext('2d');
        }
        this._labelPoint.canvas.width = data.size[0];
        this._labelPoint.canvas.height = data.size[1];
        // 已生成过的图片
        const pointImgId = data.icon + '@' + data.label;
        if (this._labelPoint.pointImgs[pointImgId]) {
            callback(this._labelPoint.pointImgs[pointImgId]);
            return;
        }
        // 新生成图片
        Tools.loadImg(data.url, img => {
            if (!img) {
                callback(null);
                return;
            }
            this._labelPoint.ctx.clearRect(0, 0, data.size[0], data.size[1]);
            this._labelPoint.ctx.drawImage(img, 0, 0, data.size[0], data.size[1]);
            // 文字
            this._labelPoint.ctx.font = (data.labelStyle.fontSize || '12px') + ' Arial';
            this._labelPoint.ctx.textAlign = 'center';
            this._labelPoint.ctx.fillStyle = data.labelStyle.color || '#000000';
            this._labelPoint.ctx.fillText(
                data.label + '',
                data.size[0] / 2 + data.labelStyle.offset[0],
                data.size[1] / 2 + data.labelStyle.offset[1],
                data.size[0],
            );
            // 图片
            const img2 = new Image();
            img2.src = this._labelPoint.canvas.toDataURL('image/png');
            this._labelPoint.pointImgs[pointImgId] = img2;
            setTimeout(() => {
                callback(img2);
            }, 0);
        });
    }

    $createLabelPoint(data, callback) {
        this._createLabelImg(data, img => {
            callback({
                geometry: {
                    type: 'Point',
                    coordinates: data.coordinates,
                },
                icon: img || data.url,
                width: data.size[0],
                height: data.size[1],
            });
        });
    }

    $addPoints(points) {
        const points2 = this._mapvLayer.dataSet.get().concat(points);
        this._mapvLayer.dataSet.set(points2);
    }

    $clearPoints() {
        this._mapvLayer.dataSet.set([]);
    }

    $onClick(callback) {
        this._mapvLayer.clickListener = callback;
    }

    $onHover(callback) {
        this._mapvLayer.hoverListener = callback;
    }
}
